<template>
  <section class="table by4">
    <ul>
      <li><label>LOI</label><label>NBR</label><label>PRIX</label><label>P.C</label></li>
    </ul>
    <ul>
      <li v-for="(l) in laws" :value="l" :key="l">
        <span v-if="reservsbylaw[l-1].length"><i class="badge">{{ config.laws[l-1] }}</i></span>
        <span v-if="reservsbylaw[l-1].length">{{reservsbylaw[l-1].length}}</span>
        <span v-if="reservsbylaw[l-1].length">{{price[l-1] | euros }}</span>
        <span v-if="reservsbylaw[l-1].length">{{ percentPrice[l-1] }}%</span>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'StatisticsProgramLaw',
  props: {
    customReservations: Array,
    tva: Boolean
  },
  data () {
    return {
    }
  },
  computed: {
    reservs: function () {
      return this.customReservations.filter(r => r.status > 1)
    },
    config: function () {
      return this.$store.getters.get_settings()
    },
    laws: function () {
      return this.config.laws.length
    },
    total: function () {
      var total = 0
      this.reservs.forEach(r => {
        if (this.tva) total = total + r.lot.calculatedprice
        else total = total + r.lot.actedprice
      })
      return total
    },
    quantity: function () {
      var quantity = []
      for (let i = 0; i < this.laws; i++) {
        quantity.push(this.reservs.filter(r => Number(r.lot.law) === i).length)
      }
      return quantity
    },
    reservsbylaw: function () {
      var reservsbylaw = []
      for (let i = 0; i < this.laws; i++) {
        reservsbylaw.push(this.reservs.filter(r => Number(r.lot.law) === i))
      }
      return reservsbylaw
    },
    price: function () {
      var price = []
      this.reservsbylaw.forEach(q => {
        if (q.length > 0) {
          var calc = 0
          q.forEach(r => {
            if (this.tva) calc = calc + r.lot.calculatedprice
            else calc = calc + r.lot.actedprice
          })
          price.push(calc)
        } else price.push(0)
      })
      return price
    },
    percent: function () {
      var percent = []
      this.quantity.forEach(q => {
        percent.push(Number(((q / this.reservs.length) * 100).toFixed(2)))
      })
      if (percent.length < 1) return ''
      return percent
    },
    percentPrice: function () {
      var percentPrice = []
      this.price.forEach(p => {
        percentPrice.push(Number(((p / this.total) * 100).toFixed(2)))
      })
      return percentPrice
    }
  }
}
</script>
